export default __webpack_public_path__ + "static/media/big-family.2538e21f.png";